import { useUserPolicyContext } from '../../context/UserPolicy';
import { useUserStatusContext } from '../../context/UserStatus';

const useShowMonthlyCare = () => {
    const { orgProperties, orgPropertiesOrganizationId } = useUserPolicyContext();
    const { permissions, activeOrgId } = useUserStatusContext();
    // Users view stands in for a billing permission until one is defined.
    return activeOrgId != null && orgPropertiesOrganizationId === activeOrgId &&
        !!orgProperties?.has_care_billing && permissions.iam.listInvites;
};

export default useShowMonthlyCare;
